import React from "react";
import Table, {
  TableRow,
} from "../../../../../../common/components/molecule/Table/Table";

export interface ClientItem {
  id: string;
  firstName: string;
  lastName: string;
  organizationRender: () => JSX.Element;
  createdAt: string;
  onClick?: () => void;
}

export interface ClientsListViewProps {
  content?: ClientItem[];
  nbFound?: number;
}

export default function ClientsListView({
  content,
  nbFound,
}: ClientsListViewProps) {
  const contentFormated: TableRow[] =
    content?.map((item) => {
      return {
        id: item.id,
        onRowClick: item.onClick,
        data: [
          item.lastName,
          item.firstName,
          item.organizationRender,
          item.createdAt,
        ],
      };
    }) || [];

  return (
    <Table
      headerTitle={["Nom", "Prénom", "Organisation", "Créé le"]}
      bodyData={contentFormated}
      NbFoundViewProps={{
        nbFound: nbFound,
        itemName: { single: "client trouvé", plurial: "clients trouvés" },
      }}
    />
  );
}
